var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwipeRemoveTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6171 6.22383H4.1751C3.76234 6.22383 3.42773 6.55843 3.42773 6.97119C3.42773 7.38395 3.76234 7.71855 4.1751 7.71855H20.6171C21.0298 7.71855 21.3644 7.38395 21.3644 6.97119C21.3644 6.55843 21.0298 6.22383 20.6171 6.22383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40664 11.4554V17.4343C9.40664 17.847 9.74124 18.1816 10.154 18.1816C10.5668 18.1816 10.9014 17.847 10.9014 17.4343V11.4554C10.9014 11.0426 10.5668 10.708 10.154 10.708C9.74124 10.708 9.40664 11.0426 9.40664 11.4554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8908 11.4554V17.4343C13.8908 17.847 14.2254 18.1816 14.6382 18.1816C15.0509 18.1816 15.3855 17.847 15.3855 17.4343V11.4554C15.3855 11.0426 15.0509 10.708 14.6382 10.708C14.2254 10.708 13.8908 11.0426 13.8908 11.4554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41719 21.1711V6.97119C6.41719 6.55843 6.08258 6.22383 5.66982 6.22383C5.25707 6.22383 4.92246 6.55843 4.92246 6.97119V21.1711C4.92246 21.7902 5.36025 22.228 5.36025 22.228C5.79805 22.6658 6.41719 22.6658 6.41719 22.6658H18.375C18.9941 22.6658 19.4319 22.228 19.4319 22.228C19.8697 21.7902 19.8697 21.1711 19.8697 21.1711V6.97119C19.8697 6.55843 19.5351 6.22383 19.1224 6.22383C18.7096 6.22383 18.375 6.55843 18.375 6.97119V21.1711H6.41719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5686 3.89107C7.91191 4.54776 7.91191 5.47646 7.91191 5.47646V6.97119C7.91191 7.38395 8.24652 7.71855 8.65927 7.71855C9.07203 7.71855 9.40664 7.38395 9.40664 6.97119V5.47646C9.40664 5.1669 9.62553 4.948 9.62553 4.948C9.84443 4.7291 10.154 4.7291 10.154 4.7291H14.6382C14.9477 4.7291 15.1666 4.948 15.1666 4.948C15.3855 5.1669 15.3855 5.47646 15.3855 5.47646V6.97119C15.3855 7.38395 15.7201 7.71855 16.1329 7.71855C16.5457 7.71855 16.8803 7.38395 16.8803 6.97119V5.47646C16.8803 4.54776 16.2236 3.89107 16.2236 3.89107C15.5669 3.23438 14.6382 3.23438 14.6382 3.23438H10.154C9.2253 3.23438 8.5686 3.89107 8.5686 3.89107Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeRemoveTask);
export default __webpack_public_path__ + "static/media/swipe-remove-task.50c948e7e664e9b0f0f7c4410aea0de6.svg";
export { ForwardRef as ReactComponent };